import { useQuery } from '@tanstack/react-query';
import { fetchDealerConfigOption } from '../services/dealerConfigOptions';
import { dealerConfigOptionKeys } from './useDealerConfigOptionsQuery';

export const useDealerConfigOptionQuery = (id?: string) =>
  useQuery({
    queryKey: dealerConfigOptionKeys.detail(id ?? ''),
    queryFn: () => fetchDealerConfigOption(id as string),
    enabled: Boolean(id),
  });
